<template>
	<div class="scoreboard">
		<div
			v-for="(cell, index) in cells"
			:key="`scoreboard-cell-${index}`"
			class="scoreboard-cell"
			:style="cell.style"
		>
			{{ cell.text }}
		</div>
	</div>
</template>

<script>
export default {
	name:  'Scoreboard',
	props: {
		cells: {
			type:    Array,
			default: () => [],
		},
	},
	computed: {},
};
</script>

<style lang="scss">
@import '@videotools/sass/fonts';

.scoreboard {
	display: flex;
	text-align: center;
	@include text-lg-2(true);
}
</style>
